import "core-js/modules/es6.object.assign";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "RichText__Inner",
  componentId: "sqyfgj-0"
})(["text-align:", ";"], function (props) {
  return props.align;
});

var RichText = function RichText(_ref) {
  var align = _ref.align,
      markup = _ref.markup,
      rest = _objectWithoutProperties(_ref, ["align", "markup"]);

  return React.createElement(Inner, Object.assign({
    align: align,
    dangerouslySetInnerHTML: {
      __html: markup
    }
  }, rest));
};

RichText.defaultProps = {
  align: 'left',
  markup: ''
};
export default RichText;